{
  "name": "ig4u-ui",
  "version": "0.0.1-SNAPSHOT.358",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=ig4u.local",
    "build": "ng build --localize",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "extract-i18n": "ng extract-i18n",
    "ssr:copy:proxy": "cp server/proxy.mjs dist/ig4u-ui/server",
    "ssr:copy:robots": "cp robots.txt dist/ig4u-ui/server",
    "ssr:copy:locales": "cp locales.json dist/ig4u-ui/server",
    "ssr:copy:sitemap": "cp sitemap.json dist/ig4u-ui/server",
    "serve:ssr:ig4u-ui": "node dist/ig4u-ui/server/proxy.mjs",
    "stats": "ng build --configuration prod --stats-json --named-chunks",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "prettier": "npx prettier --write ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.2",
    "@angular/common": "^19.2.2",
    "@angular/compiler": "^19.2.2",
    "@angular/core": "^19.2.2",
    "@angular/forms": "^19.2.2",
    "@angular/platform-browser": "^19.2.2",
    "@angular/platform-browser-dynamic": "^19.2.2",
    "@angular/platform-server": "^19.2.2",
    "@angular/router": "^19.2.2",
    "@angular/ssr": "^19.2.3",
    "@sentry/angular": "^8.42.0",
    "@sentry/cli": "^2.42.3",
    "etag": "^1.8.1",
    "express": "^4.21.2",
    "glob": "^11.0.1",
    "lightgallery": "^2.8.3",
    "loadjs": "^4.3.0",
    "mime-types": "^2.1.35",
    "ng-zorro-antd": "^19.1.0",
    "rxjs": "~7.4.0",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "xmlbuilder": "^15.1.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular-eslint/builder": "19.2.1",
    "@angular-eslint/eslint-plugin": "19.2.1",
    "@angular-eslint/eslint-plugin-template": "19.2.1",
    "@angular-eslint/schematics": "19.2.1",
    "@angular-eslint/template-parser": "19.2.1",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "^19.2.2",
    "@angular/localize": "^19.2.2",
    "@types/cloudflare-turnstile": "^0.2.2",
    "@types/etag": "^1.8.3",
    "@types/express": "^5.0.0",
    "@types/jasmine": "~5.1.7",
    "@types/loadjs": "^4.0.4",
    "@types/mime-types": "^2.1.4",
    "@types/node": "^22.13.10",
    "@typescript-eslint/eslint-plugin": "8.26.1",
    "@typescript-eslint/parser": "8.26.1",
    "eslint": "^9.22.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-plugin-prettier": "^5.2.3",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "openai": "^4.87.3",
    "prettier": "^3.5.3",
    "prettier-eslint": "^16.3.0",
    "typescript": "~5.8.2"
  }
}
